import React, { useState } from "react";
import { editorStateToText } from "./utils";
import Editor from "./Editor";
import { $getRoot, EditorState, type LexicalEditor } from "lexical";
import { useCallback, useTransition } from "react";
import { Modal } from "antd";
import { EditorVariablePickerType } from "../types";

const PromptEditor = ({
  showOpenModal = true,
  showResize = true,
  variables = [],
  value,
  onChange,
  onBlur,
  h,
  placeholder,
  title,
  border = true,
  singleLine = false,
}: {
  showOpenModal?: boolean;
  showResize?: boolean;
  variables?: EditorVariablePickerType[];
  value?: string;
  onChange?: (text: string) => void;
  onBlur?: (text: string) => void;
  h?: number;
  placeholder?: string;
  title?: string;
  border?: boolean;
  singleLine?: boolean;
}) => {
  const [open, setOpen] = useState(false);
  const [, startSts] = useTransition();

  const onChangeInput = useCallback((editorState: EditorState) => {
    const text = editorState.read(() => $getRoot().getTextContent());
    const formatValue = text
      .replaceAll("\n\n", "\n")
      .replaceAll("}}{{", "}} {{");
    onChange?.(formatValue);
  }, []);
  const onBlurInput = useCallback((editor: LexicalEditor) => {
    startSts(() => {
      const text = editorStateToText(editor)
        .replaceAll("\n\n", "\n")
        .replaceAll("}}{{", "}} {{");
      onBlur?.(text);
    });
  }, []);

  return (
    <>
      <Editor
        showResize={showResize}
        showOpenModal={showOpenModal}
        onOpenModal={() => setOpen(true)}
        variables={variables}
        h={h}
        value={value}
        onChange={onChangeInput}
        onBlur={onBlurInput}
        placeholder={placeholder}
        border={border}
        singleLine={singleLine}
      />
      <Modal
        open={open}
        onCancel={() => setOpen(false)}
        title={title}
        width={900}
        onOk={() => setOpen(false)}
        footer={null}
      >
        <Editor
          h={400}
          showResize
          showOpenModal={false}
          variables={variables}
          value={value}
          onChange={onChangeInput}
          onBlur={onBlurInput}
          placeholder={placeholder}
        />
      </Modal>
    </>
  );
};
export default React.memo(PromptEditor);
